/**
 * Initializes Select2 on specific Gravity Forms select fields with custom configurations.
 *
 * This script applies Select2 to designated select elements within Gravity Forms,
 * ensuring proper placeholder handling and configuration based on field type.
 * 
 * - Checks if Select2 is loaded before proceeding.
 * - Supports different placeholder behaviors for various field types.
 * - Removes Gravity Forms' default selected empty option where necessary.
 * 
 * @since 1.0.0
 * @returns {void}
 */
jQuery(document).ready(($) => {
	// Ensure Select2 is available before proceeding
	if (typeof $.fn.select2 !== 'function') return;

	// Mapping of selectors to their specific Select2 configurations
	const selectFields = {
		'.ginput_container_select select, .ginput_container_time select, .name_prefix_select select, .name_suffix_select select, .ginput_container_date select': {
			minimumResultsForSearch: Infinity,
			placeholder: 'Select an option' // Default placeholder
		},
		'.ginput_container .address_country select': {
			placeholder: 'Select a country',
			allowClear: true
		},
		'.ginput_container .address_state select': {
			placeholder: 'Select a state',
			allowClear: true
		}
	};

	// Iterate through the field mappings
	Object.entries(selectFields).forEach(([selector, options]) => {
		$(selector).each((index, select) => {
			const $select = $(select);
			const $placeholder = $select.find('option.gf_placeholder');
			const $firstOption = $select.children('option:first');
			let placeholderText = null;

			// Determine placeholder text
			if ($placeholder.length) {
				placeholderText = $placeholder.text().trim();
				$placeholder.prop('selected', false).text('');
			} else if ($firstOption.val() === '') {
				placeholderText = $firstOption.text().trim();
				$firstOption.text('');
			}

			// Prepare Select2 options
			const select2Options = { ...options };
			if (placeholderText) {
				select2Options.placeholder = placeholderText;
			}

			// Initialize Select2 with determined options
			$select.select2(select2Options);
		});
	});
});